import { useState } from 'react';
import type { SorterResult } from 'antd/es/table/interface';
import { API_SORT_ORDER } from '@/constants';

type Order = 1 | -1;

type SortingProps = {
  onSort?: () => void;
  order?: Order;
};

interface SortingResult<T> {
  handleSort: (props: SorterResult<T>) => void;
  resetSortOptions: () => void;
  order: Order;
  sort?: T;
}

const DEFAULT_SORT_ORDER = -1;

export const useSorting = <T>({
  onSort,
  order: defaultOrder = DEFAULT_SORT_ORDER
}: SortingProps): SortingResult<T> => {
  const [sort, setSort] = useState<T>();
  const [order, setOrder] = useState<Order>(defaultOrder);

  const resetSortOptions = () => {
    setSort(undefined);
    setOrder(DEFAULT_SORT_ORDER);
  };

  const handleSort = (sorter: SorterResult<T>) => {
    const { column, order: sortOrder } = sorter;
    const columnKey = column?.key as T;

    if (columnKey && sortOrder) {
      setSort(columnKey);
      setOrder(API_SORT_ORDER[sortOrder]);
      onSort?.();
    } else {
      resetSortOptions();
    }
  };

  return { sort, order, resetSortOptions, handleSort };
};
